import React from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { Image, H6 } from '../../../AbstractElements';
import { OrderHistoryData } from '../../../Data/Ecommerce/OrderHistory';

const OrderHistoryTable = () => {
  const orderHistoryTableData = {};
  orderHistoryTableData.orderHistoryColumns = OrderHistoryData.orderHistoryColumns.map((item) => {
    return {
      ...item,
      name: <H6>{item.name}</H6>,
    };
  });
  orderHistoryTableData.orderHistoryData = OrderHistoryData.orderHistoryData.map((item) => {
    return {
      image: (
        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
          <Image className='img-30' src={require(`../../../assets/images/product/${item.image}`)} />
        </Link>
      ),
      details: (
        <div className='product-name'>
          <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>{item.title}</Link>
          <div className='order-process'>
            <span className={`order-process-circle shipped-order ${item.statusCode}`}></span>
            {item.status}
          </div>
        </div>
      ),
      size: item.size,
      color: item.color,
      articleNumber: item.articleNumber,
      price: `$${item.price}`,
      units: item.units,
    };
  });

  return (
    <div className='order-history order-history-table  table-responsive'>
      <div id='basic-1_wrapper' className='dataTables_wrapper no-footer'>
        <DataTable pagination columns={orderHistoryTableData.orderHistoryColumns} data={orderHistoryTableData.orderHistoryData} />
      </div>
    </div>
  );
};

export default OrderHistoryTable;
